import React from 'react';
import actions from 'state/actions';
import services from 'services';
import utils from 'utils';
import CommonButton from 'components/Buttons/CommonButton';
import { actionType } from 'utils/constants';
import { useDispatch } from 'react-redux';
import useCheckBeforeAction from '../hooks';

const { MANUAL_REASSIGN_DOCUMENTS, MANUAL_REASSIGN_DOCUMENTS_NO_OCR, MANUAL_REASSIGN_DOCUMENTS_OCR } = actionType;

const { manualReassignDocuments, manualReassignOcrDocuments, manualReassignNonOcrDocuments } = services;

const apiRequests = new Map([
  [MANUAL_REASSIGN_DOCUMENTS, manualReassignDocuments],
  [MANUAL_REASSIGN_DOCUMENTS_NO_OCR, manualReassignNonOcrDocuments],
  [MANUAL_REASSIGN_DOCUMENTS_OCR, manualReassignOcrDocuments],
]);

interface IManualReassignContainerProps {
  mode: string;
  disabled: boolean;
}

const ManualReassignContainer = ({ mode, disabled }: IManualReassignContainerProps) => {
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();
  const { checkDocuments } = useCheckBeforeAction(mode);

  const getNextDocuments = async () => {
    const docFree = await checkDocuments();
    if (!docFree) return;
    try {
      const apiRequest = apiRequests.get(mode);
      if (apiRequest) {
        const { data: newDocumentsFound } = await apiRequest();
        if (newDocumentsFound) {
          dispatch(actions.documents.updateDocuments());
        } else {
          utils.app.notify('warning', t('no-new-documents-found'));
        }
      }
    } catch (e) {
      console.error(e);
      utils.app.notify('fail', e as Error);
    }
  };

  return (
    <CommonButton
      id={mode}
      disabled={disabled}
      action={getNextDocuments}
      scope="tertiary"
      value={t(`${mode}`)}
      customIcon={ mode === actionType.MANUAL_REASSIGN_DOCUMENTS_NO_OCR ? 'getNotAutomated' : 'rebatch'}
    />
  );
};

export default ManualReassignContainer;
